export const portalVersion = "5.5"; 
